import { Card, CardBody, CardHeader, CardTitle } from '@apollo/orbit';
import _ from 'lodash';
import React from 'react';

import { ProposalCheckSection } from '../../graphSettingsPage/proposalsPage/proposalCheckSection/ProposalCheckSection';
import { GraphRef } from '../../hooks/useGraphRef';

export const ProposalChecksConfigGraphPage = ({
  graphRef,
}: {
  graphRef: GraphRef;
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>General proposal configuration</CardTitle>
      </CardHeader>
      <CardBody>
        <ProposalCheckSection
          graphId={graphRef.graphId}
          graphVariant={graphRef.graphVariant}
        />
      </CardBody>
    </Card>
  );
};
